import { Pages } from "./types";

export const enum AnalyticsPageBlueprints {
  BlueprintsList = "BlueprintsList",
  BlueprintVersionsList = "BlueprintVersionsList",
  BlueprintIntegrationsList = "BlueprintIntegrationsList",
  BlueprintsGroupsList = "BlueprintsGroupsList",
}

const blueprints = "Blueprints";

export const pagesBlueprints: Pages<AnalyticsPageBlueprints> = {
  [AnalyticsPageBlueprints.BlueprintsList]: [blueprints, "Blueprints list"],
  [AnalyticsPageBlueprints.BlueprintIntegrationsList]: [blueprints, "Blueprint integrations list"],
  [AnalyticsPageBlueprints.BlueprintVersionsList]: [blueprints, "Blueprint versions list"],
  [AnalyticsPageBlueprints.BlueprintsGroupsList]: [blueprints, "Blueprints groups list"],
};
